document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const mobileToggle = document.querySelector('.mobile-menu-toggle');
  const isMobile = () => window.innerWidth <= 1024;

  document.querySelectorAll('.nav__link[aria-haspopup="true"]').forEach(btn => {
    btn.addEventListener('click', () => {
      const targetId = btn.getAttribute('aria-controls');
      const target = document.getElementById(targetId);
      const isOpen = target.classList.contains('open');

      document.querySelectorAll('.submenu').forEach(submenu => {
        submenu.classList.remove('open');
        submenu.setAttribute('hidden', 'true');
        submenu.setAttribute('aria-hidden', 'true');
      });

      document.querySelectorAll('.nav__link[aria-haspopup="true"]').forEach(link => {
        link.setAttribute('aria-expanded', 'false');
        link.classList.remove('active');
      });

      if (!isOpen) {
        target.classList.add('open');
        target.removeAttribute('hidden');
        target.setAttribute('aria-hidden', 'false');
        btn.setAttribute('aria-expanded', 'true');
        btn.classList.add('active');
        body.classList.add('submenu-opened');

        if (isMobile()) {
          const backLabel = target.querySelector('.submenu__back-label');
          if (backLabel) {
            backLabel.textContent = btn.textContent.trim();
          }
          const backHeader = target.querySelector('.submenu__mobile-header');
          if (backHeader) {
            backHeader.removeAttribute('hidden');
          }
        }
      } else {
        body.classList.remove('submenu-opened');
      }
    });
  });

  document.querySelectorAll('[data-submenu-back]').forEach(button => {
    button.addEventListener('click', () => {
      const submenu = button.closest('.submenu');
      if (submenu) {
        submenu.classList.remove('open');
        submenu.setAttribute('hidden', 'true');
        submenu.setAttribute('aria-hidden', 'true');

        body.classList.remove('submenu-opened');
      }
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      document.querySelectorAll('.submenu.open').forEach(el => {
        el.classList.remove('open');
        el.setAttribute('hidden', 'true');
        el.setAttribute('aria-hidden', 'true');
      });

      document.querySelectorAll('.nav__link[aria-haspopup="true"]').forEach(link => {
        link.classList.remove('active');
        link.setAttribute('aria-expanded', 'false');
      });

      body.classList.remove('submenu-opened');

      document.querySelector('.mobile-menu-overlay')?.classList.remove('open');
      document.querySelectorAll('.mobile-submenu').forEach(sub => sub.setAttribute('hidden', 'true'));

      document.querySelectorAll('.language-selector').forEach(selector => {
        const toggle = selector.querySelector('.language-selector__toggle');
        const dropdown = selector.querySelector('.language-selector__dropdown');
        toggle?.setAttribute('aria-expanded', 'false');
        if (dropdown) dropdown.hidden = true;
      });

      const searchOverlay = document.getElementById('search-overlay');
      if (searchOverlay?.classList.contains('open')) {
        searchOverlay.classList.remove('open');
        searchOverlay.setAttribute('hidden', 'true');
      }
    }
  });

  document.addEventListener('click', (e) => {
    document.querySelectorAll('.language-selector').forEach(selector => {
      if (!selector.contains(e.target)) {
        const toggle = selector.querySelector('.language-selector__toggle');
        const dropdown = selector.querySelector('.language-selector__dropdown');
        toggle?.setAttribute('aria-expanded', 'false');
        if (dropdown) dropdown.hidden = true;
      }
    });
  });

  if (mobileToggle) {
    mobileToggle.addEventListener('click', () => {
      const isOpen = body.classList.toggle('is-mobile-menu-open');
      const menu = document.querySelector('.mobile-menu-overlay');

      if (menu) {
        menu.classList.toggle('open');
        menu.setAttribute('aria-hidden', menu.classList.contains('open') ? 'false' : 'true');
      }

      mobileToggle.classList.toggle('is-open', isOpen);

      document.querySelectorAll('.submenu.open').forEach(submenu => {
        submenu.classList.remove('open');
        submenu.setAttribute('hidden', 'true');
        submenu.setAttribute('aria-hidden', 'true');
      });

      document.querySelectorAll('.nav__link[aria-haspopup="true"]').forEach(link => {
        link.classList.remove('active');
        link.setAttribute('aria-expanded', 'false');
      });

      body.classList.remove('submenu-opened');

      document.querySelectorAll('.mobile-submenu').forEach(sub => {
        sub.setAttribute('hidden', 'true');
      });
    });
  }

  document.querySelectorAll('.mobile-submenu-toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const target = document.getElementById(btn.dataset.target);
      if (target) {
        target.setAttribute('aria-hidden', 'false');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  document.querySelectorAll('.back-button').forEach(btn => {
    btn.addEventListener('click', () => {
      const panel = btn.closest('.mobile-menu-panel');
      if (panel) {
        panel.setAttribute('aria-hidden', 'true');
      }

      document.querySelectorAll('.mobile-submenu-toggle').forEach(b => {
        b.setAttribute('aria-expanded', 'false');
      });
    });
  });

// Language selector – toggle
  const languageSelector = document.querySelector('.language-selector');
  if (!languageSelector) return;

  const languageToggle = languageSelector?.querySelector('.language-selector__toggle');
  const languageDropdown = languageSelector?.querySelector('.language-selector__dropdown');
  const selectedLanguage = languageToggle?.querySelector('.language-selector__label');

  if (!languageToggle || !languageDropdown || !selectedLanguage) return;

  languageToggle.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();

    const isExpanded = languageToggle.getAttribute('aria-expanded') === 'true';
    languageToggle.setAttribute('aria-expanded', String(!isExpanded));
    languageDropdown.setAttribute('aria-hidden', String(isExpanded));
  });

  const currentLanguage = window.location.pathname.split('/')[1] || 'en';

  languageDropdown.querySelectorAll('[role="option"]').forEach(option => {
    const link = option.querySelector('a');
    const langCode = link.getAttribute('lang').toLowerCase();
  
    const languagePrefix = langCode.substring(0,5);
    const currentLanguagePrefix = currentLanguage.substring(0, 5);
    
    option.setAttribute('aria-selected', languagePrefix === currentLanguagePrefix ? 'true' : 'false');
  });

  document.addEventListener('click', (e) => {
    if (!languageSelector.contains(e.target)) {
      languageToggle.setAttribute('aria-expanded', 'false');
      languageDropdown.setAttribute('aria-hidden', 'true');
    }
  });
});